import { LogTimeline } from '../../../../components/generic'
import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'

export default withToolbar(LogTimeline, {
  dateFilter: {
    left: true,
  },
  timeWindow: 7 * 4,
  pdfExport: {
    title: chartTitles.daily,
    headerDate: false,
    groupBy: 'date',
    dateFormat: 'HH:mm',
  },
})
